import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cc538d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container mx-auto mt-10 border-b pb-16"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "space-y-6 my-6 mx-auto text-lg width--container" }
const _hoisted_4 = {
  style: {"font-size":"32px"},
  class: "font-extrabold text-center"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "flex width--container mx-auto justify-between font-light text-sm" }
const _hoisted_7 = { class: "text-gray-description" }
const _hoisted_8 = { class: "flex items-center space-x-4 hoverable p-2" }
const _hoisted_9 = ["onClick", "data-testid"]
const _hoisted_10 = {
  key: 1,
  class: "container mx-auto mt-16"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ml-12 text-2xl font-semibold mb-4" }, "Recommended", -1))
const _hoisted_12 = { class: "flex justify-center mb-40 space-x-5" }
const _hoisted_13 = { style: {"height":"224px"} }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "blog__content" }
const _hoisted_16 = { class: "text-xl" }
const _hoisted_17 = { class: "text-sm text-gray-description flex items-center mt-2" }
const _hoisted_18 = { class: "ml-2 text-sm text-gray-description" }

import IconShare from '@/components/Icons/IconShare.vue';
import { Icon } from '@iconify/vue';
import { onMounted, ref, watch, computed } from 'vue';
import useBlogs from '@/composables/useBlogs';
import { BlogsEntities } from '@/types/Blogs';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
let curentUrl = ref();
const winWidth = 600;
const winHeight = 600;

const blogsRecommended = ref<BlogsEntities[]>();
const {
  getBlogDetail,
  blogDetail,
  formatDate,
  getBlogs,
  filterBlogsRecommended,
  blogs,
} = useBlogs();

const shareOption = ref([
  { icon: 'akar-icons:link-chain', name: 'Copy link', key: 'copyClipboard' },
  { icon: 'akar-icons:twitter-fill', name: 'Share on Twitter', key: 'twitter' },
  {
    icon: 'akar-icons:facebook-fill',
    name: 'Share on Fackbook',
    key: 'facebook',
  },
]);

onMounted(async () => {
  await getBlogDetail();
  const payload = {
    page: 1,
  };
  await getBlogs(payload);
  getRecommended();
  curentUrl.value = window.location.href;

  const meta_des = document.querySelector('meta[property="og:description"]');
  const meta_des2 = document.querySelector('meta[name="description"]');

  if (meta_des && meta_des2) {
    meta_des.setAttribute('content', blogDetail.value?.description ?? 'blogs');
    meta_des2.setAttribute('content', blogDetail.value?.description ?? 'blogs');
  }

  const meta_title = document.querySelector('meta[property="og:title"]');
  if (meta_title) {
    meta_title.setAttribute('content', blogDetail.value?.title ?? 'blogs');
  }

  const meta_img = document.querySelector('meta[itemprop="image"]');
  const meta_ogimg = document.querySelector('meta[property="og:image"]');

  if (meta_img && meta_ogimg) {
    meta_img.setAttribute(
      'content',
      blogDetail.value?.image?.original_image_url as string
    );

    meta_ogimg.setAttribute(
      'content',
      blogDetail.value?.image?.original_image_url as string
    );
  }
});

watch(
  () => route,
  async () => {
    await getBlogDetail();
    await getRecommended();
  },
  { deep: true }
);

const getRecommended = async () => {
  const sizeRecommended = 3;
  const recommended = filterBlogsRecommended(blogs.value.entities);

  const random =
    Math.floor(Math.random() * recommended.length) - sizeRecommended;
  blogsRecommended.value =
    random > 0
      ? recommended.slice(random, random + sizeRecommended)
      : recommended.slice(0, sizeRecommended);
};

const copyClipboard = () => {
  navigator.clipboard.writeText(curentUrl.value);
};
const baseURLTwiter = 'https://www.twitter.com/share?url=';
const baseURLFb = 'https://www.facebook.com/sharer.php?u=';

const shareFacebook = () => {
  const url = baseURLFb + curentUrl.value;

  window.open(
    url,
    '',
    'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=' +
      winWidth +
      ',width=' +
      winHeight
  );
};

const shareTwiter = () => {
  const url = baseURLTwiter + curentUrl.value;

  window.open(
    url,
    '',
    'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=' +
      winWidth +
      ',width=' +
      winHeight
  );
};

const onShare = (action: string) => {
  switch (action) {
    case 'copyClipboard':
      copyClipboard();
      break;
    case 'twitter':
      shareTwiter();
      break;
    case 'facebook':
      shareFacebook();
      break;
    default:
      break;
  }
};

const blogDetailDescription = computed(() => {
  const description = blogDetail.value?.description.replaceAll(
    '<p></p>',
    '<p><br/></p>'
  );
  return description;
});

return (_ctx: any,_cache: any) => {
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(blogDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _unref(blogDetail).image.original_image_url,
            alt: "",
            class: "mx-auto rounded-lg",
            style: {"max-width":"1180px"}
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(blogDetail).title), 1),
            _createElementVNode("p", { innerHTML: _unref(blogDetailDescription) }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(formatDate)(_unref(blogDetail).updated_at as Date)), 1),
            _createVNode(_component_VDropdown, {
              "popper-hide-triggers": ['click'],
              placement: "bottom-start",
              "data-test-id": "share-blog"
            }, {
              popper: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareOption.value, (option, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "share-option",
                    key: i,
                    onClick: ($event: any) => (onShare(option.key)),
                    "data-testid": option.key
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: option.icon,
                      class: "text-gray-description w-6 h-6"
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", null, _toDisplayString(option.name), 1)
                  ], 8, _hoisted_9))
                }), 128))
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(IconShare)
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (blogsRecommended.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blogsRecommended.value, (r, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card-blog",
                style: {"width":"380px"},
                key: i
              }, [
                _createVNode(_component_router_link, {
                  to: `/landing/faqs/blog/${r.id}`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: r.image.original_image_url,
                        alt: "",
                        class: "object-contain h-full w-full rounded-md"
                      }, null, 8, _hoisted_14)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(r.title), 1),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_unref(Icon), { icon: "akar-icons:clock" }),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(formatDate)(r.updated_at as Date)), 1)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})